import React from 'react';
import { TrendingUp } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import Modal from '../ui/Modal';

const SubscriptionSuccessModal = () => {
  const app = useAppContext();

  return (
    <Modal
      isOpen={app.showSubscriptionSuccess}
      onClose={() => app.setShowSubscriptionSuccess(false)}
    >
      <div className="modal__header">
        <div className="modal__icon-wrapper modal__icon-wrapper--success">
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="3"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
              className="checkmark-path"
            />
          </svg>
        </div>
        <h2 className="modal__title">
          {app.hasCompletedTrial ? 'Welcome Back!' : 'Welcome to AlphaNQ!'}
        </h2>
        <p className="modal__subtitle">
          {app.hasCompletedTrial
            ? 'Your subscription has been activated'
            : 'Your 7-day free trial has started'}
        </p>
        <p className="modal__access-note">
          You now have full access to live Nasdaq futures signals
        </p>
      </div>
      <div className="modal__body">
        <button
          className="btn btn-primary btn-full"
          onClick={() => app.setShowSubscriptionSuccess(false)}
        >
          <TrendingUp size={18} />
          Continue
        </button>
      </div>
    </Modal>
  );
};

export default SubscriptionSuccessModal;
